"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateControlDigits = void 0;
var getFirstControlDigit = function (d1, d2, m1, m2, y1, y2, i1, i2, i3) {
    var firstControlDigit = 11 - ((3 * d1 + 7 * d2 + 6 * m1 + 1 * m2 + 8 * y1 + 9 * y2 + 4 * i1 + 5 * i2 + 2 * i3) % 11);
    return firstControlDigit === 11 ? 0 : firstControlDigit;
};
var getSecondControlDigit = function (d1, d2, m1, m2, y1, y2, i1, i2, i3, c1) {
    var secondControlDigit = 11 - ((5 * d1 + 4 * d2 + 3 * m1 + 2 * m2 + 7 * y1 + 6 * y2 + 5 * i1 + 4 * i2 + 3 * i3 + 2 * c1) % 11);
    return secondControlDigit === 11 ? 0 : secondControlDigit;
};
var getControlDigitsFromSsn = function (ssn) {
    var d1 = Number(ssn.slice(0, 1));
    var d2 = Number(ssn.slice(1, 2));
    var m1 = Number(ssn.slice(2, 3));
    var m2 = Number(ssn.slice(3, 4));
    var y1 = Number(ssn.slice(4, 5));
    var y2 = Number(ssn.slice(5, 6));
    var i1 = Number(ssn.slice(6, 7));
    var i2 = Number(ssn.slice(7, 8));
    var i3 = Number(ssn.slice(8, 9));
    var c1 = getFirstControlDigit(d1, d2, m1, m2, y1, y2, i1, i2, i3);
    var c2 = getSecondControlDigit(d1, d2, m1, m2, y1, y2, i1, i2, i3, c1);
    return [c1, c2];
};
var validateControlDigits = function (ssn) {
    var firstControlDigit = Number(ssn.slice(9, 10));
    var secondControlDigit = Number(ssn.slice(10, 11));
    var actualControlDigits = getControlDigitsFromSsn(ssn);
    return firstControlDigit === actualControlDigits[0] && secondControlDigit === actualControlDigits[1];
};
exports.validateControlDigits = validateControlDigits;
//# sourceMappingURL=validateControlDigits.js.map